/* cnpj.ts — o CNPJ como identidade da empresa.
 *
 * Mora no `core` pela mesma razão que `numero.ts` mora: é função pura e tem
 * DOIS consumidores que precisam concordar. A API decide se o cadastro passa;
 * o navegador avisa enquanto a pessoa digita. Se cada lado tivesse a sua
 * versão, a tela diria "ok" e a gravação diria "inválido" — divergência que já
 * custou caro neste produto quando o cálculo estava duplicado.
 *
 * Não é regra de precificação, e por isso não entra no motor: é vocabulário do
 * domínio, do mesmo naipe de `parseNum`.
 *
 * A FORMA NORMALIZADA (só dígitos) é o que o banco guarda e o que se compara.
 * "12.345.678/0001-90" e "12345678000190" são a MESMA empresa, e comparar o
 * texto digitado deixaria as duas conviverem como cadastros distintos.
 */
/** Só os dígitos. É esta forma que vai para o banco e para a comparação. */
export function normalizarCnpj(bruto) {
    return bruto.replace(/\D/g, '');
}
/** "12345678000190" → "12.345.678/0001-90". Fora do formato, devolve como veio. */
export function formatarCnpj(bruto) {
    const d = normalizarCnpj(bruto);
    if (d.length !== 14)
        return bruto;
    return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
}
/**
 * Dígitos verificadores da Receita (módulo 11).
 *
 * Vale a pena validar, e não só contar 14 dígitos: o CNPJ é a CHAVE que decide
 * quem pode assumir um cadastro existente. Número digitado errado vira empresa
 * fantasma no painel, e o dono de verdade esbarra nele depois sem entender por
 * quê.
 *
 * A sequência repetida ("00000000000000") passa na conta do módulo 11 e é
 * recusada à parte: é o erro de digitação mais comum que satisfaz a fórmula.
 */
export function cnpjValido(bruto) {
    const d = normalizarCnpj(bruto);
    if (d.length !== 14)
        return false;
    if (/^(\d)\1{13}$/.test(d))
        return false;
    const digito = (ate) => {
        // Pesos descem de 2 a 9 da direita para a esquerda, reiniciando em 2.
        let soma = 0;
        for (let i = 0; i < ate; i += 1) {
            soma += Number(d[ate - 1 - i]) * ((i % 8) + 2);
        }
        const resto = soma % 11;
        return resto < 2 ? 0 : 11 - resto;
    };
    return digito(12) === Number(d[12]) && digito(13) === Number(d[13]);
}
//# sourceMappingURL=cnpj.js.map